/**
 * Pull meter/wait from job JSON (camelCase / PascalCase / pricing[].type === "meter"|"wait").
 */
export function extractJobPricing(job) {
  if (!job) return { meter: null, wait: null, pricing: [], disposition: null };

  const pricing = Array.isArray(job.pricing ?? job.Pricing) ? (job.pricing ?? job.Pricing) : [];
  const disposition = job.disposition ?? job.Disposition ?? null;

  const meterPricingRow = pricing.find(
    (p) => p && String(p.type || p.Type || '').toLowerCase() === 'meter'
  );

  const waitPricingRow = pricing.find(
    (p) => p && String(p.type || p.Type || '').toLowerCase() === 'wait'
  );

  const topMeter = job.meter ?? job.Meter ?? null;
  let meter = null;
  if (topMeter || meterPricingRow) {
    const merged = { ...(meterPricingRow || {}), ...(topMeter || {}) };
    delete merged.type;
    delete merged.Type;
    delete merged.name;
    delete merged.Name;
    meter = Object.keys(merged).length ? merged : null;
  }

  let topWait = job.wait ?? job.Wait ?? null;
  if (!topWait) {
    topWait = job.price?.wait ?? job.price?.Wait ?? job.Price?.wait ?? job.Price?.Wait ?? null;
  }

  let wait = null;
  if (topWait || waitPricingRow) {
    const merged = { ...(waitPricingRow || {}), ...(topWait || {}) };
    delete merged.type;
    delete merged.Type;
    delete merged.name;
    delete merged.Name;
    wait = Object.keys(merged).length ? merged : null;
  }

  return {
    meter,
    wait,
    pricing,
    disposition,
  };
}
